import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetSomeAbonosPasarelaUseCase } from "../../bussines/useCases/GetSomeAbonosPasarelaUseCase";
import { AbonosPasarelaDtSourceImplRest } from "../../data/dataSources/AbonosPasarelaDtSourceImplRest"
import { AbonosPasarelaRepositoryImpl } from "../../data/repositories/AbonosPasarelaRepositoryImpl";
import { GetDetallesAbonoParams, GetSomeAbonosPasarelaParams } from "../../utils/params/GetSomeAbonosPasarelaParams";
import { GetDetallesAbonoUseCase } from "../../bussines/useCases/GetDetallesAbonoUseCase";

export const useAbonosPasarela = () => {
    const conceptosDtSourceRest = new AbonosPasarelaDtSourceImplRest();
    const repository = new AbonosPasarelaRepositoryImpl(conceptosDtSourceRest);

    const getSomeAbonosPasarela = async (input: GetSomeAbonosPasarelaParams) => {
        const getSomeAbonosPasarelaUseCase = new GetSomeAbonosPasarelaUseCase(repository);
        const result = await executeUseCase({ input, useCase: getSomeAbonosPasarelaUseCase });
        return result;
    }

    const getDetallesAbono = async (input: GetDetallesAbonoParams) => {
        const getDetallesAbonoUseCase = new GetDetallesAbonoUseCase(repository);
        const result = await executeUseCase({ input, useCase: getDetallesAbonoUseCase });
        return result;
    }

    return {
        getSomeAbonosPasarela,
        getDetallesAbono
    }
}